import shadowsPanel from './shadowsPanel';

export type PanelEntry = {
  component: React.ComponentType<any>;
  panelTitle: string;
};

export default {
  shadowsPanel,
} as Record<string, PanelEntry>;
